import React from 'react';

import Tooltip from './../../wix-rich-content-common/lib/Tooltip';

const ToolbarButton = ({
  tooltipText,
  button,
  tooltipOffset = { y: -20, x: 0 },
}: {
  tooltipText: string;
  button: React.ReactElement;
  tooltipOffset?: { x: number; y: number };
}) => {
  return (
    <Tooltip key={tooltipText} content={tooltipText} tooltipOffset={tooltipOffset}>
      {button}
    </Tooltip>
  );
};

export default ToolbarButton;
